<style>
    .no-items
    {
        display:inline-block;
        vertical-align:middle;
        width:99%;
        text-align:center;
        font-size:28px;
        font-weight:300;
        pointer-events:none;
        color:#545454;
    }
</style>

<template>
    <div class="result-items">
        <transition v-if="items!='loading'" name="fade" appear>
            <h4 class="no-items" v-if="!items.length">
                No items found, try to expand your search filter.
            </h4>
        </transition>
        <paginate
            ref="paginator"
            name="items"
            :list="items"
            :per="itemsPerPage"
            tag="div"
            class="paginate-langs"
            v-if="items!='loading'"
            >
                <transition-group
                    v-if="!isDevice"
                    ref="list" name="list" tag="ul" appear
                    class="item-list"
                    @before-enter="beforeEnter"
                    @enter="enter"
                    @leave="leave">
                    <!-- <li v-for="(item, index) in paginated('items')" :key="item.catNo+itemsize" :data-index="index" :class="['item', itemsize+'-item', overlay.active ? 'blur' : '']"> -->
                    <li v-for="(item, index) in paginated('items')" :key="'xresult_item_'+index" :data-index="index" :class="['item', itemsize+'-item', overlay.active ? 'blur' : '']">
                        <item-preview type="result" :item="item" :size="itemsize" :actions="['view','plus']" :draggable="true"></item-preview>
                    </li>
                </transition-group>
                <ul class="item-list" v-else>
                    <!-- <li v-for="(item, index) in paginated('items')" :key="item.catNo+itemsize" :data-index="index" :class="['item', itemsize+'-item', overlay.active ? 'blur' : '']"> -->
                     <li v-for="(item, index) in paginated('items')" :key="'result_item_'+index" :data-index="index" :class="['item', itemsize+'-item', overlay.active ? 'blur' : '']">
                        <item-preview type="result" :item="item" :size="itemsize" :actions="['view','plus']" :draggable="true"></item-preview>
                    </li>
                </ul>
            </paginate>
        <div class="pager" v-if="items!='loading' && pagerNeeded">
            <paginate-links id="pager" ref="pager" for="items" :limit="4"
            @change="onLangsPageChange"
            :show-step-links="true"
            :step-links="{next: 'Next', prev: 'Prev'}"></paginate-links>
        </div>
        <preloader key="loading" v-if="items=='loading'" ></preloader>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import Preloader from './Preloader.vue'
import ItemPreview from './ItemPreview.vue'
import { insertAfter } from '../../utils';

export default {
    props: ['items'],
    data() {
        return {
            paginate: ['items'],
            itemsPerPage: 1024,
            cartzone: -1,
            totalItems: 0,
            pagerFirst: null,
            pagerLast: null,
            pagerEl: null

        }
    },
	components: {
		ItemPreview,
        Preloader
	},
    mounted() {
        let vm = this;
        this.$set(this, 'totalItems', this.items.length)
        this.$nextTick(() => {
            this.initPager();
        })
    },
    destroyed() {
        if (!!this.pagerFirst && !!this.pagerLast) {
            this.pagerFirst.removeEventListener('click', this.firstPageClickHandler)
            this.pagerLast.removeEventListener('click', this.lastPageClickHandler)
        }
    },
    watch: {
        'itemsFilterString'() {
            this.fixPaginationPosition()
        },
        'items'() {
            this.$nextTick(function() {
                console.log("items watch>> ", this.items.length, " :: ", this.paginate.items.list.length);
                if (this.totalItems != this.items.length) {
                    this.$set(this, 'totalItems', this.items.length)
                    this.fixPaginationPosition()
                }
                if (!!this.items.length && !this.paginate.items.list.length) {
                        console.log('fix paginate bug...', this.items.length, " :: ", this.paginate.items.list.length);
                        this.$set(this.paginate.items, 'list', this.items);
                }
            })
        }
    },
    methods: {
        async initPager() {
            var vm = this, int;
            return new Promise((resolve,reject) => {
                int = setInterval(function() {
                    if (!!vm.$refs && !!vm.$refs.pager) {
                        vm.$set(vm, 'pagerEl', vm.$refs.pager.$el);
                        vm.bindFirstLastToPager();
                        clearInterval(int)
                        resolve(vm.$refs.pager.$el);
                    }
                }.bind(this), 500)
            })
        },
        async getCurrentPage() {
            let int;
            int = setInterval(function() {
                if (!!this.$refs && !!this.$refs.paginator) {
                    clearInterval(int)
                    return this.$refs.paginator.currentPage;
                }
            }.bind(this), 500)
        },
        onLangsPageChange(toPage, fromPage) {
            this.fixPaginationPosition()
        },
        async fixPaginationPosition() {
            window.scroll({ top: 0, left: 0, behavior: 'smooth' });
            this.$nextTick(async function() {
                if (this.pagerNeeded) {
                    let _pager = this.pagerEl;

                    if (!_pager) {
                        _pager = await this.initPager();
                    }
                    let curpage = this.$refs.paginator.currentPage;
                    if (!curpage) {
                        curpage = await this.getCurrentPage();
                    }
                    let _firstpage = _pager.querySelector('.first-page'),
                    _lastpage = _pager.querySelector('.last-page'),
                    _rightarrow = _pager.querySelector('.right-arrow')
                    _firstpage.classList.remove('disabled');
                    _lastpage.classList.remove('disabled');
                    if (curpage===1) {
                        _firstpage.classList.add('disabled');
                    }
                    else if (curpage===_pager.numberOfPages) {
                        _lastpage.classList.add('disabled');
                    }
                    insertAfter(_lastpage, _rightarrow)
                }
            })
        },
        bindFirstLastToPager() {
            this.$nextTick(function() {
                this.pagerFirst = document.createElement('li'),
                this.pagerLast = document.createElement('li');

                this.pagerFirst.className = "first-page disabled";
                this.pagerFirst.innerHTML = "<a>First</a>";
                this.pagerLast.className = "last-page";
                this.pagerLast.innerHTML = "<a>Last</a>";
                // FIRST / LAST (zero based)
                this.pagerFirst.addEventListener('click', this.firstPageClickHandler)
                this.pagerLast.addEventListener('click', this.lastPageClickHandler)
                console.log('insertBefore >> ', this.pagerEl,  " :: ");
                this.pagerEl.insertBefore(this.pagerFirst, this.pagerEl.firstChild);
                this.pagerEl.appendChild(this.pagerLast)
            })
        },
        firstPageClickHandler() {
            this.paginate['items'].page = 0;
        },
        lastPageClickHandler() {
                this.paginate['items'].page = this.pagerEl.numberOfPages-1;
        },
		beforeEnter: function (el) {
            el.style.opacity = 0;
            el.style.transform = 'translateY(20%)';
		},
		enter: function (el, done) {
            var vm = this;
            var delay = el.dataset.index * 120;
			setTimeout(function () {
                el.animate(
                {
                    opacity: [0,1],
                    transform: ['translateY(20%)', 'translateY(0)'],
                    easing: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)'
                },
				{ duration: vm.isIE ? 100 : 600, fill: 'forwards'}).onfinish = function() {
                    done()
                };
			}, delay)
		},
		leave: function (el, done) {
            el.style.opacity = 0;
            el.style.transform = 'translateY(120%)';
			done();
		},
        ...mapActions([
            'showShelf',
        ])
    },
    computed: {
        ...mapState([
			'overlay',
            'itemsize',
            'itemsFilterString'
		]),
        ...mapGetters([
            'isDevice',
            'isIE'
        ]),
        pagerNeeded() {
            return this.items.length > this.itemsPerPage
        }
    }
}
</script>
<style lang="stylus">
@import '~settings';
@import '~rupture';
.result-items
    --padding 8.8vh 0 0
    padding 30px 0 0
    min-height 90vh
    clear both
    +below(815px)
        padding 30px 0px 0px 0px
    +tablet(orientation: portrait)
        min-height 73vh
    /.single-line &
        padding-top 54px
        +portrait()
            min-height 77.6vh
    .paginate-langs
        padding 0 55px
        min-height 60vh
        +below(815px)
            padding 0px
    .pager
        @extend $inline-mid
        height 136px
        background #05121a
        border-top 1px solid #505a5f
        list-style none
        color #fff
        text-align center
        margin-top 75px
        +below(815px)
            width 100vw
            margin-top 25px
        ul
            @extend $inline-mid
            @extend $zero
            width 100%
            li
                @extend $zero
                width auto
                display inline-block
                vertical-align middle
                float none
                margin 0 8px
                cursor pointer
                opacity 0.7
                transition opacity 200ms ease-out
                line-height 30px
                +tablet()
                    line-height 1.6
                a
                    font-size 20px
                &.active
                    cursor default
                    width 30px
                    height 30px
                    background #05a5e6
                    border-radius 100%
                    text-align center
                    margin 0
                    opacity 1
                &.first-page
                    +below(815px)
                        display none
                &.last-page
                    +below(815px)
                        display none
                &.left-arrow
                    margin-right 36px
                    +below(815px)
                        display none
                &.right-arrow
                    margin-left 36px
                    +below(815px)
                        display none
                &.disabled
                    pointer-events none
                    cursor pointer
                    opacity 0.2
                &:hover
                    opacity 1
    .item-list
        padding 0
        margin 0 auto
        lost-utility clearfix
        transform translate3d(0,0,0)
        // backface-visibility hidden
        +below(815px)
            margin 0px 5vw
            width 90vw
		.item
            lost-column 1/6 6 
            position relative
            list-style none
            text-align center
            //margin-bottom 45px
            margin-bottom 30px
            transition transform 600ms ease-out-circ, filter 200ms ease, -webkit-filter 200ms ease
            +above(2300px)
                lost-column 1/8 8 25px
            +below(1800px)
                lost-column 1/6 6 25px
            // +below(1600px)
            //     lost-column 1/4 4
            +below(1200px)
                // lost-column 1/3 3
                lost-column 1/5 5
            +below(950px)
                lost-column 1/3 3
            +below(500px)
                lost-column 1/2 2
            &.huge-item
                lost-column 1/4 4
                position relative
                list-style none
                text-align center
                margin-bottom 45px
                transition transform 600ms ease-out-circ, filter 200ms ease, -webkit-filter 200ms ease
                +below(1600px)
                    lost-column 1/3 3
                +below(1200px)
                    lost-column 1/2 2
                +below(950px)
                    lost-column 1/1 1
			/.no-touch .blur
				-webkit-filter blur(5px) !important
				filter url('assets/blur.svg#blur')
				filter blur(5px)
/.single-line
    position absolute
    bottom 0
    width 100%
    height 80%
    .pager
        position absolute
        width 100%
        bottom 0
</style>